import { useRef, useState, useEffect, RefObject } from "react";

export function useContainerWidth(): [
  RefObject<HTMLDivElement | null>,
  number,
] {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new ResizeObserver(([entry]) => {
      const newWidth = Math.floor(entry.contentRect.width);
      setWidth((prev) => (prev === newWidth ? prev : newWidth));
    });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return [ref, width];
}
